import { makeStyles } from '@material-ui/core/styles'
import React from 'react'

import api from 'src/api'
import { BestMileVehicle } from 'src/api/gen/api'

import VehiclesTable from './Table'

interface IProps {
  isLoading: boolean
  vehicles: BestMileVehicle[]
  vehiclesCount: number
}

async function onClickExport() {
  return await api.bestmile.bestmileVehiclesExport()
}

function VehiclesList(props: IProps) {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <VehiclesTable
          data={props.vehicles}
          isLoading={props.isLoading}
          totalCount={props.vehiclesCount}
          onClickExport={onClickExport}
        />
      </div>
    </div>
  )
}

const useStyles = makeStyles({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 'inherit',
  },
  content: {
    width: '100%',
    height: '100%',
    display: 'flex',
    borderRadius: 'inherit',
    maxHeight: 'inherit',
  },
})

export default VehiclesList
